import Vue from 'vue';
import Vuex from 'vuex';
import mutations from '@/store/mutations';
import locations from './locations';
import purchase from './purchase';

import founder from './founder';

Vue.use(Vuex);

//= ======vuex store start===========
const store = new Vuex.Store({
  state: {
    // PROVIDED BY TEMPLATE
    fullScreenNav: false,
    preloader: true,
    site_name: 'PanelVue',
    page_title: null,
    user: {
      email: '',
      token: '',
    },
    logoutTimer: null,

    basePhotoUrl: 'https://s3.us-east-2.amazonaws.com/panelvue-photos/'
  },
  mutations: mutations,
  modules: {
    locations,
    purchase,
    founder,
  }
});
//= ======vuex store end===========
export default store;
